import React from 'react'

const Notice: React.FC = () => (
  <>
    <div style={{ fontFamily: 'calibri light' }}>
      <div style={{ fontSize: '40px', textAlign: 'center', background: 'aliceblue' }}>
        Attribution Report
      </div>
      <div style={{ padding: '10px 0px 0px 21px', margin: '0px' }}>
        This application uses certain open source software. As required by the terms of the open
        source license applicable to such open source software, we are providing you with the
        following notices
      </div>
      <div style={{ fontSize: '32px', textAlign: 'left' }} />
      <br />
      <div style={{ borderBottom: '2px solid #616161', boxShadow: '0 1px 1px #ccc' }}>
        <div style={{ fontSize: '32px', textAlign: 'left' }}>SUMMARY</div>
      </div>
      <div style={{ padding: '10px 0px 0px 21px', whiteSpace: 'pre-wrap' }}>
        Note: missing copyright references are marked with (*)
      </div>
      <div style={{ paddingTop: '15px' }} />
      <table border={3}>
        <tbody>
          <tr>
            <td width={50}>
              <div
                style={{
                  background: 'aliceblue',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                #
              </div>
            </td>
            <td width={250}>
              <div
                style={{
                  background: 'aliceblue',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                Library
              </div>
            </td>
            <td width={250}>
              <div
                style={{
                  background: 'aliceblue',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                Licenses
              </div>
            </td>
            <td width={250}>
              <div
                style={{
                  background: 'aliceblue',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                Copyrights
              </div>
            </td>
            <td width={250}>
              <div
                style={{
                  background: 'aliceblue',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                Notices
              </div>
            </td>
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              1
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#1'>abab-2.0.6.tgz</a>
            </td>
            <td width='250' style={{ textAlign: 'center' }}>
              <div>
                <p>BSD 3</p>
              </div>
            </td>
            <td width='250' style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright 2019 W3C and Jeff Carpenter &lt;jeffcarp@chromium.org&gt;</p>
              </div>
            </td>
            <td width='250' style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              2
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#2'>abort-controller-3.0.0.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright 2017 Toru Nagashima</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              3
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#3'>acorn-8.11.2.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright 2012-2022 by various contributors</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              4
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#4'>acorn-globals-7.0.1.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright 2014 Forbes Lindesay</p>
                <p>Copyright 2014 Forbes Lindesay</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              6
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#6'>agent-base-6.0.2.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright 2013 Nathan Rajlich &lt;nathan@tootallnate.net&gt;</p>
                <p>Copyright 2013 Nathan Rajlich &lt;nathan@tootallnate.net&gt;</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              7
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#7'>ajv-8.12.0.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright 2015-2021 Evgeny Poberezkin</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              8
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#8'>ajv-formats-2.1.1.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright 2020 Evgeny Poberezkin</p>
                <p>Copyright 2020 Evgeny Poberezkin</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              9
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#9'>angular-fontawesome-0.12.1.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright 2018 Fonticons, Inc. and contributors</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              10
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#10'>animation-15.0.0-canary.684e33d25.0.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright 2014-2020 Google, Inc</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              11
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#11'>animations-15.2.10.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright https://www.npmjs.com/~angular</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              12
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#12'>ansi-escapes-4.3.2.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>
                  Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)
                </p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              13
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#13'>ansi-regex-5.0.1.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              14
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#14'>ansi-styles-3.2.1.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              15
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#15'>ansi-styles-4.3.0.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                <p>Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              16
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#16'>ansi-styles-5.2.0.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
                <p>Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              17
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#17'>anymatch-3.1.3.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>ISC</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright 2019 Elan Shanker, Paul Miller (https://paulmillr.com)</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
            <td width={50} style={{ textAlign: 'center' }}>
              18
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <a href='#18'>applicationinsights-analytics-js-2.8.16.tgz</a>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>MIT</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }}>
              <div>
                <p>Copyright Microsoft Corporation</p>
              </div>
            </td>
            <td width={250} style={{ textAlign: 'center' }} />
          </tr>
          <tr>
          <td width={50} style={{ textAlign: 'center' }}>19</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#19">applicationinsights-channel-js-2.8.16.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>20</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#20">applicationinsights-common-2.8.16.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>21</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#21">applicationinsights-core-js-2.8.16.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>22</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#22">applicationinsights-dependencies-js-2.8.16.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>23</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#23">applicationinsights-properties-js-2.8.16.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>24</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#24">applicationinsights-shims-2.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>25</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#25">applicationinsights-web-2.8.16.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>26</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#26">argparse-1.0.10.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2012 [Vitaly Puzrin](https://github.com/puzrin)</p>
              <p>Copyright 2012 by Vitaly Puzrin</p>
              <p>Copyright 2012 "Vitaly Puzrin" (https://github.com/puzrin)</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>27</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#27">asynckit-0.4.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 Alex Indigo</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>28</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#28">auto-init-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>29</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#29">babel-jest-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>30</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#30">babel-plugin-istanbul-6.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 Istanbul Code Coverage</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>31</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#31">babel-plugin-jest-hoist-29.6.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>32</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#32">babel-preset-current-node-syntax-1.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2020 Nicolò Ribaudo and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>33</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#33">babel-preset-jest-29.6.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>34</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#34">babel__core-7.20.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>35</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#35">babel__generator-7.6.6.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>36</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#36">babel__template-7.4.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>37</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#37">babel__traverse-7.20.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>38</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#38">balanced-match-1.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2013 Julian Gruber &lt;julian@juliangruber.com&gt;
              </p>
              <p>
                Copyright 2013 Julian Gruber &lt;julian@juliangruber.com&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>39</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#39">banner-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>40</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#40">base-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>41</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#41">base64-js-1.5.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Jameson Little</p>
              <p>Copyright 2014 Jameson Little</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>42</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#42">bl-4.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2013-2019 bl contributors</p>
              <p>Copyright 2013-2019 bl contributors</p>
              <p>Copyright 2013-2019 bl contributors</p>
              <p>Copyright 2013-2019 bl contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>43</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#43">bootstrap-5.3.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2011-2023 The Bootstrap Authors</p>
              <p>Copyright and license" (#copyright-and-license)</p>
              <p>Copyright 2011-2023 ode and documentation copyright</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>44</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#44">brace-expansion-1.1.11.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2013 Julian Gruber &lt;julian@juliangruber.com&gt;
              </p>
              <p>
                Copyright 2013 Julian Gruber
                &amp;lt;julian@juliangruber.com&amp;gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>45</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#45">braces-3.0.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2019 [Jon
                Schlinkert](https://github.com/jonschlinkert)
              </p>
              <p>Copyright 2014-2018 Jon Schlinkert</p>
              <p>
                Copyright 2019 "Jon Schlinkert"
                (https://github.com/jonschlinkert)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>46</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#46">browserslist-4.22.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2014 Andrey Sitnik &lt;andrey@sitnik.ru&gt; and other
                contributors
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>47</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#47">bs-logger-0.2.6.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018 Huafu Gandon</p>
              <p>Copyright 2018 Huafu Gandon</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>48</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#48">bser-2.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Facebook Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>49</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#49">buffer-5.7.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Feross Aboukhadijeh, and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>50</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#50">buffer-from-1.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016-2018 Linus Unneb</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>51</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#51">button-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>52</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#52">call-bind-1.0.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2020 Jordan Harband</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>53</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#53">callsites-3.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>54</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#54">camelcase-5.3.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>55</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#55">camelcase-6.3.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>56</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#56">caniuse-lite-1.0.30001558.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>CC BY 4.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2023 https://www.npmjs.com/~ai</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>57</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#57">card-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>58</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#58">cdk-15.2.9.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2023 Google LLC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>59</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#59">chalk-2.4.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>60</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#60">chalk-4.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>61</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#61">char-regex-1.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2019 Richie Bendall</p>
              <p>Copyright 2019 Richie Bendall</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>62</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#62">checkbox-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>63</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#63">chips-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>64</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#64">ci-info-3.9.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 Thomas Watson Steen</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>65</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#65">circular-progress-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>66</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#66">cjs-module-lexer-1.2.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018-2020 Guy Bedford</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>67</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#67">ckeditor-4.9.10.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>68</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#68">cli-cursor-3.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>69</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#69">cli-spinners-2.9.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>70</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#70">cliui-8.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>71</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#71">clone-1.0.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2011-2015 Paul Vorbach &lt;paul@vorba.ch&gt;</p>
              <p>
                Copyright 2011-2015 "Paul Vorbach" (http://paul.vorba.ch/) and
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>72</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#72">co-4.6.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 TJ Holowaychuk &lt;tj@vision-media.ca&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>73</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#73">code-frame-7.22.13.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>74</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#74">collect-v8-coverage-1.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2019 Simen Bekkhus</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>75</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#75">color-convert-1.9.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2011-2016 Heather Arthur and Josh Junon</p>
              <p>
                Copyright 2011-2016 Heather Arthur &lt;fayearthur@gmail.com&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>76</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#76">color-convert-2.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2011-2016 Heather Arthur and Josh Junon</p>
              <p>
                Copyright 2011-2016 Heather Arthur &lt;fayearthur@gmail.com&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>77</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#77">color-name-1.1.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Dmitry Ivanov</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>78</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#78">color-name-1.1.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Dmitry Ivanov</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>79</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#79">combined-stream-1.0.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2011 Debuggable Limited &lt;felix@debuggable.com&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>80</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#80">common-15.2.10.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2023 https://www.npmjs.com/~google-wombot</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>81</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#81">commons-3.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2018
                https://github.com/sinonjs/commons/blob/main/LICENSE
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>82</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#82">compat-data-7.23.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>83</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#83">compiler-15.2.10.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2023 https://www.npmjs.com/~angular</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>84</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#84">concat-map-0.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright James Halliday</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>85</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#85">console-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>86</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#86">convert-source-map-1.9.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2013 Thorsten Lorenz</p>
              <p>Copyright 2013 Thorsten Lorenz</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>87</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#87">convert-source-map-2.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2013 Thorsten Lorenz</p>
              <p>Copyright 2013 Thorsten Lorenz</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>88</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#88">core-15.2.10.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~google-wombot</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>89</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#89">core-16.2.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>90</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#90">core-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>91</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#91">core-7.20.12.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>92</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#92">create-jest-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>93</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#93">cross-spawn-7.0.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018 Made With MOXY Lda &lt;hello@moxy.studio&gt;</p>
              <p>Copyright 2018 Made With MOXY Lda &lt;hello@moxy.studio&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>94</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#94">css-font-face-src-1.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 2</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 taobao.org</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>95</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#95">cssom-0.3.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Nikita Vasilyev</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>96</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#96">cssom-0.5.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Nikita Vasilyev</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>97</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#97">cssstyle-2.3.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Chad Walker</p>
              <p>Copyright Chad Walker</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>98</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#98">custom-elements-1.3.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2020 Andrea Giammarchi, @WebReflection</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>99</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#99">custom-elements-1.6.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 The Polymer Authors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>100</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#100">data-table-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>101</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#101">data-urls-3.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Domenic Denicola &lt;d@domenic.me&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>102</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#102">debug-4.3.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018-2021 Josh Junon</p>
              <p>Copyright 2014-2017 TJ Holowaychuk &lt;tj@vision</p>
              <p>Copyright 2018-2021 Josh Junon</p>
              <p>Copyright 2014-2017 TJ Holowaychuk &lt;tj@vision</p>
              <p>Copyright 2014-2017 TJ Holowaychuk</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>103</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#103">decimal.js-10.4.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2022 Michael Mclaughlin</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>104</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#104">dedent-1.5.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Desmond Brand (dmnd@desmondbrand.com)</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>105</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#105">deepmerge-4.3.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2012 James Halliday, Josh Duff, and other contributors
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>106</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#106">defaults-1.0.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2022 Sindre Sorhus</p>
              <p>Copyright 2015 Elijah Insua</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>107</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#107">define-data-property-1.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2023 Jordan Harband</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>108</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#108">delayed-stream-1.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2011 Debuggable Limited &lt;felix@debuggable.com&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>109</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#109">density-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>110</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#110">detect-newline-3.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>111</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#111">dialog-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>112</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#112">diff-sequences-29.6.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>113</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#113">dom-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>114</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#114">domexception-4.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Domenic Denicola</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>115</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#115">dommatrix-1.0.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2020 thednp</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>116</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#116">drawer-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>117</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#117">dynamicproto-js-1.1.9.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>118</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#118">effects-15.4.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~robwormald</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>119</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#119">electron-to-chromium-1.4.569.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018 Kilian Valkhof</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>120</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#120">elevation-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>121</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#121">emittery-0.13.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>122</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#122">emoji-regex-8.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>123</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#123">entities-4.5.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 2</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Felix Böhm</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>124</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#124">entity-15.4.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~brandonroberts</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>125</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#125">environment-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>126</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#126">error-ex-1.3.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 JD Ballard</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>127</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#127">esbuild-0.17.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2020 Evan Wallace</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>128</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#128">esbuild-wasm-0.17.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2020 Evan Wallace</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>129</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#129">escalade-3.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Luke Edwards &lt;luke.edwards05@gmail.com&gt;
                (lukeed.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>130</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#130">escape-string-regexp-1.0.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>131</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#131">escape-string-regexp-2.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>132</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#132">escodegen-2.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 2</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2012 Yusuke Suzuki" (http://github.com/Constellation)
              </p>
              <p>
                Copyright 2012 Yusuke Suzuki (twitter: @Constellation) and other
                contributors
              </p>
              <p>
                Copyright 2012 Yusuke Suzuki" (http://github.com/Constellation)
              </p>
              <p>
                Copyright 2012 Yusuke Suzuki (twitter: @Constellation) and other
                contributors
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>133</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#133">esprima-4.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 2</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright JS Foundation and other contributors,
                https://js.foundation/
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>134</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#134">estraverse-5.3.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 2</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2012-2016 Yusuke Suzuki</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>135</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#135">esutils-2.0.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 2</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2013 [Yusuke Suzuki](http://github.com/Constellation)
              </p>
              <p>
                Copyright 2013 "Yusuke Suzuki" (http://github.com/Constellation)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>136</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#136">event-target-shim-5.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Toru Nagashima</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>137</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#137">eventsource-2.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright EventSource GitHub organisation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>138</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#138">execa-5.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>139</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#139">exit-0.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2013 "Cowboy" Ben Alman</p>
              <p>Copyright 2013 "Cowboy" Ben Alman</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>140</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#140">expect-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>141</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#141">expect-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>142</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#142">expect-utils-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>143</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#143">fab-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>144</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#144">fake-timers-10.3.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2010-2014 Christian Johansen</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>145</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#145">fake-timers-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>146</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#146">fast-deep-equal-3.1.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017 Evgeny Poberezkin</p>
              <p>Copyright 2017 Evgeny Poberezkin</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>147</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#147">fast-json-stable-stringify-2.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2013 James Halliday</p>
              <p>Copyright 2017 Evgeny Poberezkin</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>148</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#148">fb-watchman-2.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and its affiliates.</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>149</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#149">feature-targeting-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>150</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#150">fetch-cookie-2.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Unlicense</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Author: Val (valeriangalliat)</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>151</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#151">file-saver-2.0.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 "Eli Grey" (http://eligrey.com)</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>152</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#152">fill-range-7.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Jon Schlinkert</p>
              <p>
                Copyright 2019 "Jon Schlinkert"
                (https://github.com/jonschlinkert)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>153</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#153">find-up-4.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>154</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#154">flex-layout-15.0.0-beta.42.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~angular</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>155</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#155">floating-label-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>156</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#156">focus-ring-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>157</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#157">font-awesome-4.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>SIL Open Font 1.1</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Dave Gandy</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>158</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#158">fontawesome-common-types-0.2.36.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>CC BY 4.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Font Awesome https://fontawesome.com/</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            https://fontawesome.com/
            https://www.npmjs.org/package/@fortawesome/fontawesome-common-types
          </td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>159</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#159">fontawesome-common-types-6.4.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2023 Fonticons, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>160</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#160">fontawesome-svg-core-1.2.36.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>CC BY 4.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Font Awesome https://fontawesome.com/</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            https://fontawesome.com/
            https://www.npmjs.org/package/@fortawesome/fontawesome-svg-core
          </td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>161</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#161">form-data-4.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2012 Felix Geisendörfer (felix@debuggable.com) and
                contributors
              </p>
              <p>
                Copyright 2012 Felix Geisendörfer (felix@debuggable.com) and
                contributors
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>162</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#162">form-field-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>163</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#163">forms-15.2.10.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~google-wombot</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>164</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#164">free-solid-svg-icons-6.4.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2023 Fonticons, Inc</p>
              <p>Copyright IconDefinition;</p>
              <p>Copyright exports.definition;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>165</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#165">fs.realpath-1.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>166</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#166">fsevents-2.3.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2010-2020 by Philipp Dunkel</p>
              <p>Copyright 2010-2020 by Philipp Dunkel</p>
              <p>Copyright 2010-2020 by Philipp Dunkel</p>
              <p>Copyright 2010-2020 by Philipp Dunkel</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>167</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#167">function-bind-1.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2013 Raynos</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>168</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#168">gen-mapping-0.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2022 Justin Ridgewell &lt;jridgewell@google.com&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>169</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#169">gen-mapping-0.3.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2022 Justin Ridgewell &lt;jridgewell@google.com&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>170</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#170">generate-js-3.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2016 Michaelangelo Jong</p>
              <p>Copyright 2014-2016 Michaelangelo Jong</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>171</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#171">generator-7.20.14.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>172</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#172">generator-7.23.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>173</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#173">gensync-1.0.0-beta.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018 Logan Smyth &lt;loganfsmyth@gmail.com&gt;</p>
              <p>Copyright 2018 Logan Smyth &lt;loganfsmyth@gmail.com&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>174</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#174">get-caller-file-2.0.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018 Stefan Penner</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>175</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#175">get-intrinsic-1.2.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2020 Jordan Harband</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>176</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#176">get-package-type-0.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2020 CFWare, LLC</p>
              <p>Copyright 2020 CFWare, LLC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>177</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#177">get-stream-6.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>178</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#178">glob-7.2.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z. Schlueter and Contributors</p>
              <p>Copyright Isaac Z. Schlueter and Contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>179</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#179">globals-11.12.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>180</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#180">globals-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>181</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#181">gopd-1.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2022 Jordan Harband</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>182</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#182">graceful-fs-4.1.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>183</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#183">graceful-fs-4.2.11.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2011-2022 Isaac Z. Schlueter</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>184</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#184">hammerjs-2.0.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2011-2014 by Jorik Tangelder (Eight Media)</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>185</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#185">has-flag-3.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>186</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#186">has-flag-4.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>187</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#187">has-property-descriptors-1.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2022 Inspect JS</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>188</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#188">has-proto-1.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2022 Inspect JS</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>189</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#189">has-symbols-1.0.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 Jordan Harband</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>190</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#190">hasown-2.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Jordan Harband and contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>191</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#191">helper-compilation-targets-7.22.15.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>192</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#192">helper-environment-visitor-7.22.20.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>193</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#193">helper-function-name-7.23.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>194</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#194">helper-hoist-variables-7.22.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>195</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#195">helper-module-imports-7.22.15.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>196</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#196">helper-module-transforms-7.23.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>197</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#197">helper-plugin-utils-7.22.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>198</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#198">helper-simple-access-7.22.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>199</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#199">helper-split-export-declaration-7.22.6.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>200</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#200">helper-string-parser-7.22.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>201</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#201">helper-validator-identifier-7.22.20.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>202</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#202">helper-validator-option-7.22.15.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>203</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#203">helpers-7.23.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>204</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#204">highlight-7.22.20.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>205</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#205">html-encoding-sniffer-3.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Domenic Denicola &lt;d@domenic.me&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>206</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#206">html-escaper-2.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017 by Andrea Giammarchi - @WebReflection</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>207</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#207">http-proxy-agent-5.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2013 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
              </p>
              <p>
                Copyright 2013 Nathan Rajlich "nathan@tootallnate.net"
                (mailto:nathan@tootallnate.net)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>208</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#208">https-proxy-agent-5.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2013 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>209</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#209">human-signals-2.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2019 ehmicky &lt;ehmicky@gmail.com&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>210</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#210">icon-button-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>211</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#211">iconv-lite-0.6.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2011 Alexander Shtuchkin</p>
              <p>Copyright 2011 Alexander Shtuchkin</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>212</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#212">ieee754-1.2.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2008 Fair Oaks Labs, Inc</p>
              <p>Copyright 2008 Fair Oaks Labs, Inc</p>
              <p>Copyright 2008 Fair Oaks Labs, Inc</p>
              <p>Copyright 2008 Fair Oaks Labs, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>213</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#213">image-list-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>214</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#214">immutable-4.3.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Lee Byron and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>215</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#215">import-local-3.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>216</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#216">imurmurhash-0.1.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2013 Gary Court, Jens Taylor</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>217</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#217">inflight-1.0.6.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>218</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#218">inherits-2.0.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>219</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#219">inlineresources-1.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~cburgmer</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>220</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#220">is-arrayish-0.2.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 JD Ballard</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>221</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#221">is-core-module-2.13.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Dave Justice</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>222</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#222">is-fullwidth-code-point-3.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>223</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#223">is-generator-fn-2.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>224</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#224">is-interactive-1.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>225</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#225">is-number-7.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Jon Schlinkert</p>
              <p>
                Copyright 2018 [Jon
                Schlinkert](https://github.com/jonschlinkert)
              </p>
              <p>
                Copyright 2018 "Jon Schlinkert"
                (https://github.com/jonschlinkert)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>226</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#226">is-potential-custom-element-name-1.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>227</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#227">is-stream-2.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>228</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#228">is-unicode-supported-0.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>229</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#229">isexe-2.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>230</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#230">istanbul-lib-coverage-2.0.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>231</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#231">istanbul-lib-coverage-3.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2012-2015 Yahoo</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>232</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#232">istanbul-lib-instrument-5.2.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2012-2015 Yahoo</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>233</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#233">istanbul-lib-instrument-6.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2012-2015 Yahoo</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>234</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#234">istanbul-lib-report-3.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2012-2015 Yahoo</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>235</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#235">istanbul-lib-report-3.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>236</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#236">istanbul-lib-source-maps-4.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Yahoo!</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>237</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#237">istanbul-reports-3.0.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>238</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#238">istanbul-reports-3.1.6.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2012-2015 Yahoo</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>239</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#239">jest-29.5.6.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>240</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#240">jest-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>241</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#241">jest-changed-files-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>242</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#242">jest-circus-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>243</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#243">jest-cli-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>244</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#244">jest-config-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>245</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#245">jest-diff-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>246</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#246">jest-docblock-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>247</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#247">jest-each-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>248</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#248">jest-environment-jsdom-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>249</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#249">jest-environment-node-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>250</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#250">jest-get-type-29.6.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>251</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#251">jest-haste-map-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>252</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#252">jest-leak-detector-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>253</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#253">jest-matcher-utils-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>254</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#254">jest-message-util-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>255</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#255">jest-mock-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>256</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#256">jest-pnp-resolver-1.2.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2016 Maël NisonPermission is hereby granted, free of
                charge, to any person obtaining a copy of this softw
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>257</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#257">jest-preset-angular-13.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017 Michał Pierzchała</p>
              <p>Copyright 2017 Michał Pierzchała</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>258</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#258">jest-regex-util-29.6.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>259</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#259">jest-resolve-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>260</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#260">jest-resolve-dependencies-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>261</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#261">jest-runner-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>262</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#262">jest-runtime-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>263</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#263">jest-snapshot-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>264</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#264">jest-util-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>265</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#265">jest-validate-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>266</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#266">jest-watcher-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>267</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#267">jest-worker-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>268</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#268">js-tokens-4.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2015 2016, 2017, 2018 Simon Lydell</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>269</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#269">js-yaml-3.14.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2011-2015 by Vitaly Puzrin</p>
              <p>Copyright 2011-2015 by Vitaly Puzrin</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>270</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#270">jsdom-20.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>271</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#271">jsdom-20.0.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2010 Elijah Insua</p>
              <p>Copyright 2010 Elijah Insua</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>272</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#272">jsesc-2.5.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>273</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#273">json-parse-even-better-errors-2.3.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017 Kat Marchán</p>
              <p>Copyright npm, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>274</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#274">json-schema-traverse-1.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017 Evgeny Poberezkin</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>275</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#275">json5-2.2.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2012-2018 Aseem Kishore</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>276</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#276">jsonc-parser-3.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018 Microsoft</p>
              <p>Copyright Microsoft</p>
              <p>Copyright 2018 Microsoft</p>
              <p>Copyright Microsoft</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>277</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#277">kendo-theme-material-3.34.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2021 Progress (Apache 2.0)</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>278</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#278">kleur-3.0.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Luke Edwards &lt;luke.edwards05@gmail.com&gt;
                (lukeed.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>279</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#279">layout-grid-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>280</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#280">leven-3.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>281</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#281">line-ripple-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>282</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#282">linear-progress-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>283</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#283">lines-and-columns-1.2.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Brian Donovan</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>284</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#284">list-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>285</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#285">load-nyc-config-1.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2019 Contributors</p>
              <p>Copyright 2019 Contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>286</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#286">locate-path-5.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>287</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#287">lodash.memoize-4.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright jQuery Foundation and other contributors
                &lt;https://jquery.org/&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>288</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#288">log-symbols-4.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>289</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#289">lru-cache-5.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>290</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#290">lru-cache-6.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z</p>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>291</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#291">magic-string-0.30.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018 Rich Harris</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>292</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#292">make-dir-4.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>293</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#293">make-error-1.3.6.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Julien Fontanet</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>294</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#294">makeerror-1.0.12.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Naitik Shah</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>295</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#295">material-15.2.9.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2023 Google LLC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>296</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#296">material-moment-adapter-15.2.9.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2023 Google LLC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>297</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#297">menu-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>298</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#298">menu-surface-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>299</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#299">merge-stream-2.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Stephen Sugden &lt;me@stephensugden.com&gt;
                (stephensugden.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>300</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#300">micromatch-4.0.6.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Jon Schlinkert</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>301</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#301">mime-db-1.52.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright (c) 2014 Jonathan Ong me@jongleberry.com Copyright (c)
                2015-2022 Douglas Christopher Wilson doug@somethingdoug.com
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>302</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#302">mime-types-2.1.35.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2015 Douglas Christopher Wilson
                &lt;doug@somethingdoug.com&gt;
              </p>
              <p>Copyright 2014 Jonathan Ong &lt;me@jongleberry.com&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>303</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#303">mimic-fn-2.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>304</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#304">minimatch-3.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z. Schlueter and Contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>305</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#305">moment-2.29.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright JS Foundation and other contributors</p>
              <p>Copyright JS Foundation and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>306</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#306">ms-2.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 Zeit, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>307</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#307">msal-1.4.18.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>308</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#308">msal-angular-3.0.6.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>309</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#309">msal-browser-3.3.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
              <p>Copyright Microsoft Corporation</p>
              <p>Copyright Microsoft Corporation</p>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>310</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#310">msal-common-14.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>311</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#311">natural-compare-1.4.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2012-2015 Lauri Rooden &lt;lauri@rooden.ee&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>312</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#312">ng-bootstrap-14.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015-2018 Angular ng</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>313</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#313">ng-multiselect-dropdown-0.2.14.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Nilesh Patel</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>314</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#314">ng2-ckeditor-1.3.7.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016-2018 Simon Babay</p>
              <p>Copyright 2016-2018 Simon Babay</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>315</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#315">ngx-device-detector-5.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~ahsanayaz</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>316</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#316">ngx-doc-viewer-2.0.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Marcel Hoekstra (marcel.hoekstra@outlook.com) (MIT)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>317</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#317">ngx-file-drop-10.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>2017 Copyright (c) Georgipeltekov</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>318</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#318">ngx-moment-3.5.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2013-2019 Uri Shaked and contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>319</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#319">ngx-owl-carousel-o-15.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~vit.andriiovskyi</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>320</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#320">node-12.20.55.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>321</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#321">node-fetch-2.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 David Frank</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>322</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#322">node-int64-0.4.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Robert Kieffer</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>323</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#323">node-releases-2.0.13.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2017 Sergey Rubanov (https://github.com/chicoxyzzy)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>324</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#324">normalize-path-3.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2018 [Jon
                Schlinkert](https://github.com/jonschlinkert)
              </p>
              <p>Copyright 2014-2018 Jon Schlinkert</p>
              <p>
                Copyright 2018 "Jon Schlinkert"
                (https://github.com/jonschlinkert)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>325</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#325">notched-outline-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>326</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#326">npm-run-path-4.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>327</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#327">nwsapi-2.2.7.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2007-2019 Diego Perini</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>328</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#328">object-inspect-1.13.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2013 James Halliday</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>329</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#329">once-1.4.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>330</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#330">once-2.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2020 Nathan Rajlich</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>331</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#331">onetime-5.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>332</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#332">ora-5.4.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>333</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#333">p-limit-2.3.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>334</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#334">p-limit-3.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>335</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#335">p-locate-4.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>336</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#336">p-try-2.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>337</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#337">parse-json-5.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>338</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#338">parse5-7.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2013-2019 Ivan Nikulin</p>
              <p>Copyright 2013-2019 Ivan Nikulin</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>339</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#339">parser-7.23.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2012-2014 by various contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>340</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#340">path-exists-4.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>341</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#341">path-is-absolute-1.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>342</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#342">path-key-3.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>343</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#343">path-parse-1.0.7.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Javier Blanco</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>344</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#344">pdfjs-dist-2.16.105.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Collaborators: Yury Delendik, Brendan Dahl</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>345</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#345">picocolors-1.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2021 Alexey Raspopov, Kostiantyn Denysov, Anton
                Verinov
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>346</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#346">picomatch-2.3.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2017 Jon Schlinkert"
                (https://github.com/jonschlinkert)
              </p>
              <p>Copyright 2017 Jon Schlinkert</p>
              <p>Copyright 2017 Jon Schlinkert</p>
              <p>
                Copyright 2017 Jon Schlinkert"
                (https://github.com/jonschlinkert)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>347</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#347">pirates-4.0.6.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016-2018 Ari Porad</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>348</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#348">pkg-dir-4.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>349</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#349">platform-browser-15.2.10.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~google-wombot</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>350</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#350">platform-browser-dynamic-15.2.10.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~google-wombot</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>351</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#351">plugin-syntax-async-generators-7.8.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>352</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#352">plugin-syntax-bigint-7.8.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>353</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#353">plugin-syntax-class-properties-7.12.13.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>354</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#354">plugin-syntax-import-meta-7.10.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>355</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#355">plugin-syntax-json-strings-7.8.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>356</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#356">plugin-syntax-jsx-7.22.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>357</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#357"
              >plugin-syntax-logical-assignment-operators-7.10.4.tgz</a
            >
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>358</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#358"
              >plugin-syntax-nullish-coalescing-operator-7.8.3.tgz</a
            >
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>359</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#359">plugin-syntax-numeric-separator-7.10.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>360</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#360">plugin-syntax-object-rest-spread-7.8.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>361</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#361">plugin-syntax-optional-catch-binding-7.8.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>362</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#362">plugin-syntax-optional-chaining-7.8.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>363</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#363">plugin-syntax-top-level-await-7.14.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>364</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#364">plugin-syntax-typescript-7.22.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>365</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#365">popper.js-1.16.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 **Federico Zivolo**</p>
              <p>Copyright 2016 Federico Zivolo and contributors</p>
              <p>Copyright 2016 Federico Zivolo</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>366</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#366">pretty-format-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>367</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#367">progress-indicator-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>368</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#368">prompts-2.4.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018 Terkel Gjervig Nielsen</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>369</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#369">psl-1.9.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017 Lupo Montero lupomontero@gmail.com</p>
              <p>
                Copyright 2017 Lupo Montero "lupomontero@gmail.com"
                (mailto:lupomontero@gmail.com)
              </p>
              <p>
                Copyright 2017 Lupo Montero "lupomontero@gmail.com"
                (mailto:lupomontero@gmail.com)
              </p>
              <p>Copyright 2017 Lupo Montero lupomontero@gmail.com</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>370</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#370">punycode-1.4.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>371</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#371">punycode-2.3.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>372</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#372">pure-rand-6.0.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018 Nicolas DUBIEN</p>
              <p>Copyright 2018 Nicolas DUBIEN</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>373</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#373">qs-6.11.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2014 Nathan LaFreniere and other "contributors"
                (https://github.com/ljharb/qs/graphs/contributors)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>374</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#374">querystringify-2.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2015 Unshift.io, Arnout Kazemier, the Contributors
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>375</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#375">radio-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>376</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#376">rasterizehtml-1.3.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2017 rasterizeHTML.js contributors</p>
              <p>Copyright 2014-2017 rasterizeHTML.js contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>377</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#377">react-is-18.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Facebook, Inc. and its affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>378</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#378">readable-stream-3.6.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Node.js contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>379</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#379">remapping-2.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2019 Google LLC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>380</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#380">reporters-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>381</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#381">require-directory-2.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2011 Troy Goode &lt;troygoode@gmail.com&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>382</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#382">require-from-string-2.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Vsevolod Strukchinsky &lt;floatdrop@gmail.com&gt;
                (github.com/floatdrop)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>383</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#383">requires-port-1.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2015 Unshift.io, Arnout Kazemier, the Contributors
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>384</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#384">reselect-4.1.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015-2018 Reselect Contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>385</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#385">resolve-1.22.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2012 James Halliday</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>386</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#386">resolve-cwd-3.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>387</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#387">resolve-from-5.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>388</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#388">resolve-uri-3.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2019 Justin Ridgewell &lt;jridgewell@google.com&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>389</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#389">resolve.exports-2.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Luke Edwards &lt;luke.edwards05@gmail.com&gt;
                (lukeed.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>390</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#390">restore-cursor-3.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>391</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#391">ripple-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>392</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#392">router-15.2.10.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~google-wombot</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>393</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#393">router-store-15.4.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~robwormald</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>394</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#394">rtl-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>395</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#395">rxjs-6.6.7.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015-2018 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>396</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#396">rxjs-7.8.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015-2018 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>397</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#397">rxjs-compat-6.6.7.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015-2018 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>398</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#398">safe-buffer-5.2.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Feross Aboukhadijeh</p>
              <p>Copyright Feross Aboukhadijeh</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>399</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#399">safer-buffer-2.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018 Nikita Skovoroda &lt;chalkerx@gmail.com&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>400</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#400">safevalues-0.3.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Collaborators: Google-wombot</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>401</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#401">sane-domparser-error-0.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 2</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright christoph burgmer</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>402</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#402">saxes-6.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>403</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#403">schema-0.1.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2019 CFWare, LLC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>404</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#404">schemas-29.6.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>405</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#405">schematics-15.4.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~robwormald</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>406</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#406">schematics-16.2.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>407</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#407">secure-web-storage-1.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017 Michaelangelo Jong</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>408</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#408">segmented-button-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>409</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#409">select-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>410</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#410">semver-6.3.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z. Schlueter and Contributors</p>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>411</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#411">semver-7.5.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z</p>
              <p>Copyright Isaac Z. Schlueter and Contributors</p>
              <p>Copyright Isaac Z. Schlueter and Contributors</p>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>412</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#412">semver-7.5.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z. Schlueter and Contributors</p>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>413</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#413">set-array-1.1.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2022 Justin Ridgewell &lt;jridgewell@google.com&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>414</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#414">set-cookie-parser-2.6.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2015 Nathan Friedly &lt;nathan@nfriedly.com&gt;
                (http://nfriedly.com/)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>415</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#415">set-function-length-1.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Jordan Harband and contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>416</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#416">shape-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>417</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#417">shebang-command-2.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Kevin Mårtensson &lt;kevinmartensson@gmail.com&gt;
                (github.com/kevva)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>418</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#418">shebang-regex-3.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>419</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#419">side-channel-1.0.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2019 Jordan Harband</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>420</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#420">signal-exit-3.0.7.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Contributors</p>
              <p>Copyright 2015 Contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>421</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#421">signalr-7.0.12.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 Richard Morris</p>
              <p>Copyright 2010-2019 Google LLC. http</p>
              <p>Copyright 2017 Yoshifumi Kawai</p>
              <p>Copyright 2019 David Fowler</p>
              <p>Copyright .NET Foundation and Contributors</p>
              <p>Copyright 2007 James Newton-King</p>
              <p>Copyright .NET Foundation and Contributors</p>
              <p>Copyright 2019-2020 West Wind Technologies</p>
              <p>Copyright 2013-2017 Milosz Krajewski</p>
              <p>Copyright 2014-2018 Michael Daines</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>422</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#422">sisteransi-1.0.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2018 Terkel Gjervig Nielsen</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>423</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#423">slash-3.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>424</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#424">slider-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>425</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#425">snackbar-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>426</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#426">source-map-0.6.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 2</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2009-2011 Mozilla Foundation and contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>427</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#427">source-map-0.7.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2009-2011 Mozilla Foundation and contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>428</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#428">source-map-29.6.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>429</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#429">source-map-support-0.5.13.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Evan Wallace</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>430</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#430">sourcemap-codec-1.4.15.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Rich Harris</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>431</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#431">sprintf-js-1.0.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Alexandru Marasteanu</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>432</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#432">stack-utils-2.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>433</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#433">stack-utils-2.0.6.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016-2022 Isaac Z. Schlueter</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>434</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#434">store-15.4.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright https://www.npmjs.com/~brandonroberts</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>435</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#435">string-length-4.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>436</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#436">string-width-4.2.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>437</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#437">string_decoder-1.3.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Node.js contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>438</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#438">strip-ansi-6.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>439</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#439">strip-bom-4.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>440</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#440">strip-final-newline-2.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>441</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#441">strip-json-comments-3.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>442</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#442">supports-color-5.5.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>443</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#443">supports-color-7.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>444</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#444">supports-color-8.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>445</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#445">supports-preserve-symlinks-flag-1.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2022 Inspect JS</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>446</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#446">switch-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>447</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#447">symbol-tree-3.2.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Joris van der Wel</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>448</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#448">tab-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>449</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#449">tab-bar-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>450</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#450">tab-indicator-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>451</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#451">tab-scroller-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>452</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#452">template-7.20.7.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>453</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#453">template-7.22.15.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>454</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#454">test-exclude-6.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 Contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>455</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#455">test-result-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>456</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#456">test-sequencer-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>457</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#457">textfield-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>458</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#458">theme-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>459</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#459">tmpl-1.0.5.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Naitik Shah</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>460</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#460">to-fast-properties-2.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Petka Antonov</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>461</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#461">to-regex-range-5.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Jon Schlinkert</p>
              <p>
                Copyright 2019 "Jon Schlinkert"
                (https://github.com/jonschlinkert)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>462</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#462">tokens-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>463</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#463">tooltip-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>464</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#464">top-app-bar-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>465</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#465">touch-target-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>466</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#466">tough-cookie-4.0.4.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>467</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#467">tough-cookie-4.1.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 3</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright and License</p>
              <p>Copyright 2015 Salesforce.com, Inc</p>
              <p>Copyright 2015 Salesforce.com, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>468</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#468">tr46-0.0.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 -</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>469</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#469">tr46-3.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Sebastian Mayr</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>470</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#470">trace-mapping-0.3.20.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2022 Justin Ridgewell &lt;justin@ridgewell.name&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>471</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#471">transform-29.7.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>472</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#472">traverse-7.23.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>473</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#473">ts-jest-29.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 Kulshekhar Kabra</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>474</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#474">tslib-1.14.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD Zero</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>475</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#475">tslib-2.6.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD Zero</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>476</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#476">type-detect-4.0.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2013 Jake Luer &lt;jake@alogicalparadox.com&gt;
                (http://alogicalparadox.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>477</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#477">type-fest-0.21.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https:/sindresorhus.com)
              </p>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https:/sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>478</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#478">typebox-0.27.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017-2023 Haydn Paterson</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>479</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#479">types-29.6.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Meta Platforms, Inc. and affiliates</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>480</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#480">types-7.23.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
              <p>Copyright 2014 Sebastian McKenzie and other contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>481</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#481">typography-15.0.0-canary.684e33d25.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014-2020 Google, Inc</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>482</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#482">universalify-0.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017 Ryan Zimmerman &lt;opensrc@ryanzim.com&gt;</p>
              <p>Copyright 2017 Ryan Zimmerman &lt;opensrc@ryanzim.com&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>483</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#483">update-browserslist-db-1.0.13.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2022 Andrey Sitnik &lt;andrey@sitnik.ru&gt; and other
                contributors
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>484</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#484">uri-js-4.4.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 2</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2011 Gary Court</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>485</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#485">url-0.11.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Joyent, Inc. and other Node contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>486</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#486">url-parse-1.5.10.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2015 Unshift.io, Arnout Kazemier, the Contributors
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>487</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#487">util-deprecate-1.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2014 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
              </p>
              <p>
                Copyright 2014 Nathan Rajlich "nathan@tootallnate.net"
                (mailto:nathan@tootallnate.net)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>488</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#488">v8-coverage-0.2.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017 Contributors</p>
              <p>Copyright 2015-2017 Charles Samborski</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>489</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#489">v8-to-istanbul-9.1.3.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2017 Contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>490</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#490">w3c-xmlserializer-4.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Sebastian Mayr</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>491</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#491">walker-1.0.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2013 Naitik Shah</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>492</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#492">wcwidth-1.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2012 by Jun Woong</p>
              <p>Copyright 2012 by Jun Woong</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>493</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#493">web-animations-js-2.3.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Alan Cutter, Shane Stephens</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>494</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#494">web-streams-polyfill-3.2.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2020 Mattias Buelens</p>
              <p>Copyright 2016 Diwank Singh Tomer</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>495</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#495">webidl-conversions-3.0.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 2</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Domenic Denicola</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>496</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#496">webidl-conversions-7.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>BSD 2</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Domenic Denicola</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>497</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#497">whatwg-encoding-2.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Domenic Denicola &lt;d@domenic.me&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>498</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#498">whatwg-mimetype-3.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Domenic Denicola &lt;d@domenic.me&gt;</p>
              <p>Copyright Domenic Denicola &lt;d@domenic.me&gt;</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>499</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#499">whatwg-url-11.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Sebastian Mayr</p>
              <p>Copyright Sebastian Mayr</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>500</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#500">whatwg-url-5.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015-2016 Sebastian Mayr</p>
              <p>Copyright 2015-2016 Sebastian Mayr</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>501</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#501">which-2.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>502</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#502">wrap-ansi-7.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>503</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#503">wrappy-1.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>504</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#504">write-file-atomic-4.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Rebecca Turner</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>505</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#505">ws-7.5.9.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright 2011 Einar Otto Stangvik &lt;einaros@gmail.com&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>506</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#506">ws-8.14.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 Luigi Pinca and contributors</p>
              <p>Copyright 2013 Arnout Kazemier and contributors</p>
              <p>
                Copyright 2011 Einar Otto Stangvik &lt;einaros@gmail.com&gt;
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>507</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#507">xml-name-validator-4.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Apache 2.0</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Author: Domenic Denicola d@domenic.me</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>508</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#508">xmlchars-2.2.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Louis-Dominique Dubeau and contributors to xmlchars
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>509</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#509">xmlserializer-0.6.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2014 Christoph Burgmer and contributors</p>
              <p>Copyright 2014 Christoph Burgmer and contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>510</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#510">y18n-5.0.8.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2015 Contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>511</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#511">yallist-3.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>512</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#512">yallist-4.0.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Isaac Z</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>513</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#513">yargs-17.0.29.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>514</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#514">yargs-17.6.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2010-2014 Contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>515</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#515">yargs-parser-21.0.2.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright Microsoft Corporation</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>516</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#516">yargs-parser-21.1.1.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>ISC</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2016 Contributors</p>
              <p>Copyright 2016 Contributors</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>517</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#517">yocto-queue-0.1.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>
                Copyright Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
                (https://sindresorhus.com)
              </p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        <tr>
          <td width={50} style={{ textAlign: 'center' }}>518</td>
          <td width={250} style={{ textAlign: 'center' }}>
            <a href="#518">zone.js-0.12.0.tgz</a>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>MIT</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}>
            <div>
              <p>Copyright 2010-2022 Google LLC. https</p>
              <p>Copyright 2010-2022 Google LLC. https</p>
              <p>Copyright 2010-2022 Google LLC. https</p>
            </div>
          </td>
          <td width={250} style={{ textAlign: 'center' }}></td>
        </tr>
        </tbody>
      </table>
      <br />
    <div style={{fontSize: '32px', textAlign: 'left'}}>APPENDIX</div>
    <div
      style={{
        padding: '30px 0px 0px 21px',
        display: 'block',
        fontSize: '1.12em',
        fontWeight: 'bold'
      }}
    >
      <div style={{textDecoration: 'underline', textUnderlinePosition: 'under'}}>
        License Details
      </div>
    </div>
    <br />
    <div style={{padding: '10px 0px 0px 21px', fontWeight: 'bold'}} id={'L7'}>
      1. BSD 2
    </div>
    <div style={{padding: '10px 0px 0px 21px', whiteSpace: 'pre-wrap'}}>
      License Text:
      <p style={{margin: '0px'}}>
        Note: This license has also been called the “Simplified BSD License” and
        the “FreeBSD License” Copyright YEAR COPYRIGHT HOLDER Redistribution and
        use in source and binary forms, with or without modification, are
        permitted provided that the following conditions are met: 1.
        Redistributions of source code must retain the above copyright notice,
        this list of conditions and the following disclaimer. 2. Redistributions
        in binary form must reproduce the above copyright notice, this list of
        conditions and the following disclaimer in the documentation and/or
        other materials provided with the distribution. THIS SOFTWARE IS
        PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY
        EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
        IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
        PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR
        CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
        EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
        PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
        PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
        LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
        NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
        SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </p>
    </div>
    <br />
    <div style={{padding: '10px 0px 0px 21px', fontWeight: 'bold'}} id={'L9'}>
      2. Apache 2.0
    </div>
    <div style={{padding: '10px 0px 0px 21px', whiteSpace: 'pre-wrap'}}>
      License Text:
      <p style={{margin: '0px'}}>
        TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION 1.
        Definitions. “License” shall mean the terms and conditions for use,
        reproduction, and distribution as defined by Sections 1 through 9 of
        this document. “Licensor” shall mean the copyright owner or entity
        authorized by the copyright owner that is granting the License. “Legal
        Entity” shall mean the union of the acting entity and all other entities
        that control, are controlled by, or are under common control with that
        entity. For the purposes of this definition, “control” means (i) the
        power, direct or indirect, to cause the direction or management of such
        entity, whether by contract or otherwise, or (ii) ownership of fifty
        percent (50%) or more of the outstanding shares, or (iii) beneficial
        ownership of such entity. “You” (or “Your”) shall mean an individual or
        Legal Entity exercising permissions granted by this License. “Source”
        form shall mean the preferred form for making modifications, including
        but not limited to software source code, documentation source, and
        configuration files. “Object” form shall mean any form resulting from
        mechanical transformation or translation of a Source form, including but
        not limited to compiled object code, generated documentation, and
        conversions to other media types. “Work” shall mean the work of
        authorship, whether in Source or Object form, made available under the
        License, as indicated by a copyright notice that is included in or
        attached to the work (an example is provided in the Appendix below).
        “Derivative Works” shall mean any work, whether in Source or Object
        form, that is based on (or derived from) the Work and for which the
        editorial revisions, annotations, elaborations, or other modifications
        represent, as a whole, an original work of authorship. For the purposes
        of this License, Derivative Works shall not include works that remain
        separable from, or merely link (or bind by name) to the interfaces of,
        the Work and Derivative Works thereof. “Contribution” shall mean any
        work of authorship, including the original version of the Work and any
        modifications or additions to that Work or Derivative Works thereof,
        that is intentionally submitted to Licensor for inclusion in the Work by
        the copyright owner or by an individual or Legal Entity authorized to
        submit on behalf of the copyright owner. For the purposes of this
        definition, “submitted” means any form of electronic, verbal, or written
        communication sent to the Licensor or its representatives, including but
        not limited to communication on electronic mailing lists, source code
        control systems, and issue tracking systems that are managed by, or on
        behalf of, the Licensor for the purpose of discussing and improving the
        Work, but excluding communication that is conspicuously marked or
        otherwise designated in writing by the copyright owner as “Not a
        Contribution.” “Contributor” shall mean Licensor and any individual or
        Legal Entity on behalf of whom a Contribution has been received by
        Licensor and subsequently incorporated within the Work. 2. Grant of
        Copyright License. Subject to the terms and conditions of this License,
        each Contributor hereby grants to You a perpetual, worldwide,
        non-exclusive, no-charge, royalty-free, irrevocable copyright license to
        reproduce, prepare Derivative Works of, publicly display, publicly
        perform, sublicense, and distribute the Work and such Derivative Works
        in Source or Object form. 3. Grant of Patent License. Subject to the
        terms and conditions of this License, each Contributor hereby grants to
        You a perpetual, worldwide, non-exclusive, no-charge, royalty-free,
        irrevocable (except as stated in this section) patent license to make,
        have made, use, offer to sell, sell, import, and otherwise transfer the
        Work, where such license applies only to those patent claims licensable
        by such Contributor that are necessarily infringed by their
        Contribution(s) alone or by combination of their Contribution(s) with
        the Work to which such Contribution(s) was submitted. If You institute
        patent litigation against any entity (including a cross-claim or
        counterclaim in a lawsuit) alleging that the Work or a Contribution
        incorporated within the Work constitutes direct or contributory patent
        infringement, then any patent licenses granted to You under this License
        for that Work shall terminate as of the date such litigation is filed.
        4. Redistribution. You may reproduce and distribute copies of the Work
        or Derivative Works thereof in any medium, with or without
        modifications, and in Source or Object form, provided that You meet the
        following conditions: You must give any other recipients of the Work or
        Derivative Works a copy of this License; and You must cause any modified
        files to carry prominent notices stating that You changed the files; and
        You must retain, in the Source form of any Derivative Works that You
        distribute, all copyright, patent, trademark, and attribution notices
        from the Source form of the Work, excluding those notices that do not
        pertain to any part of the Derivative Works; and If the Work includes a
        “NOTICE” text file as part of its distribution, then any Derivative
        Works that You distribute must include a readable copy of the
        attribution notices contained within such NOTICE file, excluding those
        notices that do not pertain to any part of the Derivative Works, in at
        least one of the following places: within a NOTICE text file distributed
        as part of the Derivative Works; within the Source form or
        documentation, if provided along with the Derivative Works; or, within a
        display generated by the Derivative Works, if and wherever such
        third-party notices normally appear. The contents of the NOTICE file are
        for informational purposes only and do not modify the License. You may
        add Your own attribution notices within Derivative Works that You
        distribute, alongside or as an addendum to the NOTICE text from the
        Work, provided that such additional attribution notices cannot be
        construed as modifying the License. You may add Your own copyright
        statement to Your modifications and may provide additional or different
        license terms and conditions for use, reproduction, or distribution of
        Your modifications, or for any such Derivative Works as a whole,
        provided Your use, reproduction, and distribution of the Work otherwise
        complies with the conditions stated in this License. 5. Submission of
        Contributions. Unless You explicitly state otherwise, any Contribution
        intentionally submitted for inclusion in the Work by You to the Licensor
        shall be under the terms and conditions of this License, without any
        additional terms or conditions. Notwithstanding the above, nothing
        herein shall supersede or modify the terms of any separate license
        agreement you may have executed with Licensor regarding such
        Contributions. 6. Trademarks. This License does not grant permission to
        use the trade names, trademarks, service marks, or product names of the
        Licensor, except as required for reasonable and customary use in
        describing the origin of the Work and reproducing the content of the
        NOTICE file. 7. Disclaimer of Warranty. Unless required by applicable
        law or agreed to in writing, Licensor provides the Work (and each
        Contributor provides its Contributions) on an “AS IS” BASIS, WITHOUT
        WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied,
        including, without limitation, any warranties or conditions of TITLE,
        NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE.
        You are solely responsible for determining the appropriateness of using
        or redistributing the Work and assume any risks associated with Your
        exercise of permissions under this License. 8. Limitation of Liability.
        In no event and under no legal theory, whether in tort (including
        negligence), contract, or otherwise, unless required by applicable law
        (such as deliberate and grossly negligent acts) or agreed to in writing,
        shall any Contributor be liable to You for damages, including any
        direct, indirect, special, incidental, or consequential damages of any
        character arising as a result of this License or out of the use or
        inability to use the Work (including but not limited to damages for loss
        of goodwill, work stoppage, computer failure or malfunction, or any and
        all other commercial damages or losses), even if such Contributor has
        been advised of the possibility of such damages. 9. Accepting Warranty
        or Additional Liability. While redistributing the Work or Derivative
        Works thereof, You may choose to offer, and charge a fee for, acceptance
        of support, warranty, indemnity, or other liability obligations and/or
        rights consistent with this License. However, in accepting such
        obligations, You may act only on Your own behalf and on Your sole
        responsibility, not on behalf of any other Contributor, and only if You
        agree to indemnify, defend, and hold each Contributor harmless for any
        liability incurred by, or claims asserted against, such Contributor by
        reason of your accepting any such warranty or additional liability. END
        OF TERMS AND CONDITIONS
      </p>
    </div>
    <br />
    <div style={{padding: '10px 0px 0px 21px', fontWeight: 'bold'}} id={'L6'}>
      3. BSD 3
    </div>
    <div style={{padding: '10px 0px 0px 21px', whiteSpace: 'pre-wrap'}}>
      License Text:
      <p style={{margin: '0px'}}>
        Copyright (c) year owner. Redistribution and use in source and binary
        forms, with or without modification, are permitted provided that the
        following conditions are met: 1. Redistributions of source code must
        retain the above copyright notice, this list of conditions and the
        following disclaimer. 2. Redistributions in binary form must reproduce
        the above copyright notice, this list of conditions and the following
        disclaimer in the documentation and/or other materials provided with the
        distribution. 3. Neither the name of the copyright holder nor the names
        of its contributors may be used to endorse or promote products derived
        from this software without specific prior written permission. THIS
        SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
        AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
        THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
        PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR
        CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
        EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
        PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
        PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
        LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
        NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
        SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </p>
    </div>
    <br />
    <div style={{padding: '10px 0px 0px 21px', fontWeight: 'bold'}} id={'L448'}>
      4. BSD Zero
    </div>
    <div style={{padding: '10px 0px 0px 21px', whiteSpace: 'pre-wrap'}}>
      License Text:
      <p style={{margin: '0px'}}>
        Note: Despite its name, Zero-Clause BSD is an alteration of the ISC
        license, and is not textually derived from licenses in the BSD family.
        Zero-Clause BSD was originally approved under the name “Free Public
        License 1.0.0”. Zero-Clause BSD ============= Permission to use, copy,
        modify, and/or distribute this software for any purpose with or without
        fee is hereby granted. THE SOFTWARE IS PROVIDED “AS IS” AND THE AUTHOR
        DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL
        IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
        AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
        DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
        PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
        ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
        THIS SOFTWARE
      </p>
    </div>
    <br />
    <div style={{padding: '10px 0px 0px 21px', fontWeight: 'bold'}} id={'L1004'}>
      5. SIL Open Font 1.1
    </div>
    <div style={{padding: '10px 0px 0px 21px', whiteSpace: 'pre-wrap'}}>
      License Text:
      <p style={{margin: '0px'}}>
        PREAMBLE The goals of the Open Font License (OFL) are to stimulate
        worldwide development of collaborative font projects, to support the
        font creation efforts of academic and linguistic communities, and to
        provide a free and open framework in which fonts may be shared and
        improved in partnership with others. The OFL allows the licensed fonts
        to be used, studied, modified and redistributed freely as long as they
        are not sold by themselves. The fonts, including any derivative works,
        can be bundled, embedded, redistributed and/or sold with any software
        provided that any reserved names are not used by derivative works. The
        fonts and derivatives, however, cannot be released under any other type
        of license. The requirement for fonts to remain under this license does
        not apply to any document created using the fonts or their derivatives.
        DEFINITIONS “Font Software” refers to the set of files released by the
        Copyright Holder(s) under this license and clearly marked as such. This
        may include source files, build scripts and documentation. “Reserved
        Font Name” refers to any names specified as such after the copyright
        statement(s). “Original Version” refers to the collection of Font
        Software components as distributed by the Copyright Holder(s). “Modified
        Version” refers to any derivative made by adding to, deleting, or
        substituting – in part or in whole – any of the components of the
        Original Version, by changing formats or by porting the Font Software to
        a new environment. “Author” refers to any designer, engineer,
        programmer, technical writer or other person who contributed to the Font
        Software. PERMISSION & CONDITIONS Permission is hereby granted, free of
        charge, to any person obtaining a copy of the Font Software, to use,
        study, copy, merge, embed, modify, redistribute, and sell modified and
        unmodified copies of the Font Software, subject to the following
        conditions: 1) Neither the Font Software nor any of its individual
        components, in Original or Modified Versions, may be sold by itself. 2)
        Original or Modified Versions of the Font Software may be bundled,
        redistributed and/or sold with any software, provided that each copy
        contains the above copyright notice and this license. These can be
        included either as stand-alone text files, human-readable headers or in
        the appropriate machine-readable metadata fields within text or binary
        files as long as those fields can be easily viewed by the user. 3) No
        Modified Version of the Font Software may use the Reserved Font Name(s)
        unless explicit written permission is granted by the corresponding
        Copyright Holder. This restriction only applies to the primary font name
        as presented to the users. 4) The name(s) of the Copyright Holder(s) or
        the Author(s) of the Font Software shall not be used to promote, endorse
        or advertise any Modified Version, except to acknowledge the
        contribution(s) of the Copyright Holder(s) and the Author(s) or with
        their explicit written permission. 5) The Font Software, modified or
        unmodified, in part or in whole, must be distributed entirely under this
        license, and must not be distributed under any other license. The
        requirement for fonts to remain under this license does not apply to any
        document created using the Font Software. TERMINATION This license
        becomes null and void if any of the above conditions are not met.
        DISCLAIMER THE FONT SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF
        ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO ANY
        WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
        NONINFRINGEMENT OF COPYRIGHT, PATENT, TRADEMARK, OR OTHER RIGHT. IN NO
        EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE FOR ANY CLAIM, DAMAGES OR
        OTHER LIABILITY, INCLUDING ANY GENERAL, SPECIAL, INDIRECT, INCIDENTAL,
        OR CONSEQUENTIAL DAMAGES, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        OTHERWISE, ARISING FROM, OUT OF THE USE OR INABILITY TO USE THE FONT
        SOFTWARE OR FROM OTHER DEALINGS IN THE FONT SOFTWARE.
      </p>
    </div>
    <br />
    <div style={{padding: '10px 0px 0px 21px', fontWeight: 'bold'}} id={'L354'}>
      6. CC BY 4.0
    </div>
    <div style={{padding: '10px 0px 0px 21px', whiteSpace: 'pre-wrap'}}>
      License Text:
      <p style={{margin: '0px'}}>
        Creative Commons Attribution 4.0 International Creative Commons
        Corporation ("Creative Commons") is not a law firm and does not provide
        legal services or legal advice. Distribution of Creative Commons public
        licenses does not create a lawyer-client or other relationship. Creative
        Commons makes its licenses and related information available on an
        "as-is" basis. Creative Commons gives no warranties regarding its
        licenses, any material licensed under their terms and conditions, or any
        related information. Creative Commons disclaims all liability for
        damages resulting from their use to the fullest extent possible. Using
        Creative Commons Public Licenses Creative Commons public licenses
        provide a standard set of terms and conditions that creators and other
        rights holders may use to share original works of authorship and other
        material subject to copyright and certain other rights specified in the
        public license below. The following considerations are for informational
        purposes only, are not exhaustive, and do not form part of our licenses.
        Considerations for licensors: Our public licenses are intended for use
        by those authorized to give the public permission to use material in
        ways otherwise restricted by copyright and certain other rights. Our
        licenses are irrevocable. Licensors should read and understand the terms
        and conditions of the license they choose before applying it. Licensors
        should also secure all rights necessary before applying our licenses so
        that the public can reuse the material as expected. Licensors should
        clearly mark any material not subject to the license. This includes
        other CC-licensed material, or material used under an exception or
        limitation to copyright. More considerations for licensors :
        wiki.creativecommons.org/Considerations_for_licensors Considerations for
        the public: By using one of our public licenses, a licensor grants the
        public permission to use the licensed material under specified terms and
        conditions. If the licensor's permission is not necessary for any
        reason–for example, because of any applicable exception or limitation to
        copyright–then that use is not regulated by the license. Our licenses
        grant only permissions under copyright and certain other rights that a
        licensor has authority to grant. Use of the licensed material may still
        be restricted for other reasons, including because others have copyright
        or other rights in the material. A licensor may make special requests,
        such as asking that all changes be marked or described. Although not
        required by our licenses, you are encouraged to respect those requests
        where reasonable. More considerations for the public :
        wiki.creativecommons.org/Considerations_for_licensees Creative Commons
        Attribution 4.0 International Public License By exercising the Licensed
        Rights (defined below), You accept and agree to be bound by the terms
        and conditions of this Creative Commons Attribution 4.0 International
        Public License ("Public License"). To the extent this Public License may
        be interpreted as a contract, You are granted the Licensed Rights in
        consideration of Your acceptance of these terms and conditions, and the
        Licensor grants You such rights in consideration of benefits the
        Licensor receives from making the Licensed Material available under
        these terms and conditions. Section 1 – Definitions. a. Adapted Material
        means material subject to Copyright and Similar Rights that is derived
        from or based upon the Licensed Material and in which the Licensed
        Material is translated, altered, arranged, transformed, or otherwise
        modified in a manner requiring permission under the Copyright and
        Similar Rights held by the Licensor. For purposes of this Public
        License, where the Licensed Material is a musical work, performance, or
        sound recording, Adapted Material is always produced where the Licensed
        Material is synched in timed relation with a moving image. b. Adapter's
        License means the license You apply to Your Copyright and Similar Rights
        in Your contributions to Adapted Material in accordance with the terms
        and conditions of this Public License. c. Copyright and Similar Rights
        means copyright and/or similar rights closely related to copyright
        including, without limitation, performance, broadcast, sound recording,
        and Sui Generis Database Rights, without regard to how the rights are
        labeled or categorized. For purposes of this Public License, the rights
        specified in Section 2(b)(1)-(2) are not Copyright and Similar Rights.
        d. Effective Technological Measures means those measures that, in the
        absence of proper authority, may not be circumvented under laws
        fulfilling obligations under Article 11 of the WIPO Copyright Treaty
        adopted on December 20, 1996, and/or similar international agreements.
        e. Exceptions and Limitations means fair use, fair dealing, and/or any
        other exception or limitation to Copyright and Similar Rights that
        applies to Your use of the Licensed Material. f. Licensed Material means
        the artistic or literary work, database, or other material to which the
        Licensor applied this Public License. g. Licensed Rights means the
        rights granted to You subject to the terms and conditions of this Public
        License, which are limited to all Copyright and Similar Rights that
        apply to Your use of the Licensed Material and that the Licensor has
        authority to license. h. Licensor means the individual(s) or entity(ies)
        granting rights under this Public License. i. Share means to provide
        material to the public by any means or process that requires permission
        under the Licensed Rights, such as reproduction, public display, public
        performance, distribution, dissemination, communication, or importation,
        and to make material available to the public including in ways that
        members of the public may access the material from a place and at a time
        individually chosen by them. j. Sui Generis Database Rights means rights
        other than copyright resulting from Directive 96/9/EC of the European
        Parliament and of the Council of 11 March 1996 on the legal protection
        of databases, as amended and/or succeeded, as well as other essentially
        equivalent rights anywhere in the world. k. You means the individual or
        entity exercising the Licensed Rights under this Public License. Your
        has a corresponding meaning. Section 2 – Scope. a. License grant. 1.
        Subject to the terms and conditions of this Public License, the Licensor
        hereby grants You a worldwide, royalty-free, non-sublicensable,
        non-exclusive, irrevocable license to exercise the Licensed Rights in
        the Licensed Material to: A. reproduce and Share the Licensed Material,
        in whole or in part; and B. produce, reproduce, and Share Adapted
        Material. 2. Exceptions and Limitations. For the avoidance of doubt,
        where Exceptions and Limitations apply to Your use, this Public License
        does not apply, and You do not need to comply with its terms and
        conditions. 3. Term. The term of this Public License is specified in
        Section 6(a). 4. Media and formats; technical modifications allowed. The
        Licensor authorizes You to exercise the Licensed Rights in all media and
        formats whether now known or hereafter created, and to make technical
        modifications necessary to do so. The Licensor waives and/or agrees not
        to assert any right or authority to forbid You from making technical
        modifications necessary to exercise the Licensed Rights, including
        technical modifications necessary to circumvent Effective Technological
        Measures. For purposes of this Public License, simply making
        modifications authorized by this Section 2(a)(4) never produces Adapted
        Material. 5. Downstream recipients. A. Offer from the Licensor –
        Licensed Material. Every recipient of the Licensed Material
        automatically receives an offer from the Licensor to exercise the
        Licensed Rights under the terms and conditions of this Public License.
        B. No downstream restrictions. You may not offer or impose any
        additional or different terms or conditions on, or apply any Effective
        Technological Measures to, the Licensed Material if doing so restricts
        exercise of the Licensed Rights by any recipient of the Licensed
        Material. 6. No endorsement. Nothing in this Public License constitutes
        or may be construed as permission to assert or imply that You are, or
        that Your use of the Licensed Material is, connected with, or sponsored,
        endorsed, or granted official status by, the Licensor or others
        designated to receive attribution as provided in Section 3(a)(1)(A)(i).
        b. Other rights. 1. Moral rights, such as the right of integrity, are
        not licensed under this Public License, nor are publicity, privacy,
        and/or other similar personality rights; however, to the extent
        possible, the Licensor waives and/or agrees not to assert any such
        rights held by the Licensor to the limited extent necessary to allow You
        to exercise the Licensed Rights, but not otherwise. 2. Patent and
        trademark rights are not licensed under this Public License. 3. To the
        extent possible, the Licensor waives any right to collect royalties from
        You for the exercise of the Licensed Rights, whether directly or through
        a collecting society under any voluntary or waivable statutory or
        compulsory licensing scheme. In all other cases the Licensor expressly
        reserves any right to collect such royalties. Section 3 – License
        Conditions. Your exercise of the Licensed Rights is expressly made
        subject to the following conditions. a. Attribution. 1. If You Share the
        Licensed Material (including in modified form), You must: A. retain the
        following if it is supplied by the Licensor with the Licensed Material:
        i. identification of the creator(s) of the Licensed Material and any
        others designated to receive attribution, in any reasonable manner
        requested by the Licensor (including by pseudonym if designated); ii. a
        copyright notice; iii. a notice that refers to this Public License; iv.
        a notice that refers to the disclaimer of warranties; v. a URI or
        hyperlink to the Licensed Material to the extent reasonably practicable;
        B. indicate if You modified the Licensed Material and retain an
        indication of any previous modifications; and C. indicate the Licensed
        Material is licensed under this Public License, and include the text of,
        or the URI or hyperlink to, this Public License. 2. You may satisfy the
        conditions in Section 3(a)(1) in any reasonable manner based on the
        medium, means, and context in which You Share the Licensed Material. For
        example, it may be reasonable to satisfy the conditions by providing a
        URI or hyperlink to a resource that includes the required information.
        3. If requested by the Licensor, You must remove any of the information
        required by Section 3(a)(1)(A) to the extent reasonably practicable. 4.
        If You Share Adapted Material You produce, the Adapter's License You
        apply must not prevent recipients of the Adapted Material from complying
        with this Public License. Section 4 – Sui Generis Database Rights. Where
        the Licensed Rights include Sui Generis Database Rights that apply to
        Your use of the Licensed Material: a. for the avoidance of doubt,
        Section 2(a)(1) grants You the right to extract, reuse, reproduce, and
        Share all or a substantial portion of the contents of the database; b.
        if You include all or a substantial portion of the database contents in
        a database in which You have Sui Generis Database Rights, then the
        database in which You have Sui Generis Database Rights (but not its
        individual contents) is Adapted Material; and c. You must comply with
        the conditions in Section 3(a) if You Share all or a substantial portion
        of the contents of the database. For the avoidance of doubt, this
        Section 4 supplements and does not replace Your obligations under this
        Public License where the Licensed Rights include other Copyright and
        Similar Rights. Section 5 – Disclaimer of Warranties and Limitation of
        Liability. a. Unless otherwise separately undertaken by the Licensor, to
        the extent possible, the Licensor offers the Licensed Material as-is and
        as-available, and makes no representations or warranties of any kind
        concerning the Licensed Material, whether express, implied, statutory,
        or other. This includes, without limitation, warranties of title,
        merchantability, fitness for a particular purpose, non-infringement,
        absence of latent or other defects, accuracy, or the presence or absence
        of errors, whether or not known or discoverable. Where disclaimers of
        warranties are not allowed in full or in part, this disclaimer may not
        apply to You. b. To the extent possible, in no event will the Licensor
        be liable to You on any legal theory (including, without limitation,
        negligence) or otherwise for any direct, special, indirect, incidental,
        consequential, punitive, exemplary, or other losses, costs, expenses, or
        damages arising out of this Public License or use of the Licensed
        Material, even if the Licensor has been advised of the possibility of
        such losses, costs, expenses, or damages. Where a limitation of
        liability is not allowed in full or in part, this limitation may not
        apply to You. c. The disclaimer of warranties and limitation of
        liability provided above shall be interpreted in a manner that, to the
        extent possible, most closely approximates an absolute disclaimer and
        waiver of all liability. Section 6 – Term and Termination. a. This
        Public License applies for the term of the Copyright and Similar Rights
        licensed here. However, if You fail to comply with this Public License,
        then Your rights under this Public License terminate automatically. b.
        Where Your right to use the Licensed Material has terminated under
        Section 6(a), it reinstates: 1. automatically as of the date the
        violation is cured, provided it is cured within 30 days of Your
        discovery of the violation; or 2. upon express reinstatement by the
        Licensor. c. For the avoidance of doubt, this Section 6(b) does not
        affect any right the Licensor may have to seek remedies for Your
        violations of this Public License. d. For the avoidance of doubt, the
        Licensor may also offer the Licensed Material under separate terms or
        conditions or stop distributing the Licensed Material at any time;
        however, doing so will not terminate this Public License. e. Sections 1,
        5, 6, 7, and 8 survive termination of this Public License. Section 7 –
        Other Terms and Conditions. a. The Licensor shall not be bound by any
        additional or different terms or conditions communicated by You unless
        expressly agreed. b. Any arrangements, understandings, or agreements
        regarding the Licensed Material not stated herein are separate from and
        independent of the terms and conditions of this Public License. Section
        8 – Interpretation. a. For the avoidance of doubt, this Public License
        does not, and shall not be interpreted to, reduce, limit, restrict, or
        impose conditions on any use of the Licensed Material that could
        lawfully be made without permission under this Public License. b. To the
        extent possible, if any provision of this Public License is deemed
        unenforceable, it shall be automatically reformed to the minimum extent
        necessary to make it enforceable. If the provision cannot be reformed,
        it shall be severed from this Public License without affecting the
        enforceability of the remaining terms and conditions. c. No term or
        condition of this Public License will be waived and no failure to comply
        consented to unless expressly agreed to by the Licensor. d. Nothing in
        this Public License constitutes or may be interpreted as a limitation
        upon, or waiver of, any privileges and immunities that apply to the
        Licensor or You, including from the legal processes of any jurisdiction
        or authority. Creative Commons is not a party to its public licenses.
        Notwithstanding, Creative Commons may elect to apply one of its public
        licenses to material it publishes and in those instances will be
        considered the "Licensor." The text of the Creative Commons public
        licenses is dedicated to the public domain under the CC0 Public Domain
        Dedication. Except for the limited purpose of indicating that material
        is shared under a Creative Commons public license or as otherwise
        permitted by the Creative Commons policies published at
        creativecommons.org/policies, Creative Commons does not authorize the
        use of the trademark "Creative Commons" or any other trademark or logo
        of Creative Commons without its prior written consent including, without
        limitation, in connection with any unauthorized modifications to any of
        its public licenses or any other arrangements, understandings, or
        agreements concerning use of licensed material. For the avoidance of
        doubt, this paragraph does not form part of the public licenses.
        Creative Commons may be contacted at creativecommons.org.
      </p>
    </div>
    <br />
    <div style={{padding: '10px 0px 0px 21px', fontWeight: 'bold'}} id={'L33'}>
      7. ISC
    </div>
    <div style={{padding: '10px 0px 0px 21px', whiteSpace: 'pre-wrap'}}>
      License Text:
      <p style={{margin: '0px'}}>
        Copyright YEAR OWNER Permission to use, copy, modify, and/or distribute
        this software for any purpose with or without fee is hereby granted,
        provided that the above copyright notice and this permission notice
        appear in all copies. THE SOFTWARE IS PROVIDED “AS IS” AND THE AUTHOR
        DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL
        IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
        AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
        DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
        PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
        ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
        THIS SOFTWARE
      </p>
    </div>
    <br />
    <div style={{padding: '10px 0px 0px 21px', fontWeight: 'bold'}} id={'L10'}>
      8. MIT
    </div>
    <div style={{padding: '10px 0px 0px 21px', whiteSpace: 'pre-wrap'}}>
      License Text:
      <p style={{margin: '0px'}}>
        Copyright YEAR COPYRIGHT HOLDER Permission is hereby granted, free of
        charge, to any person obtaining a copy of this software and associated
        documentation files (the “Software”), to deal in the Software without
        restriction, including without limitation the rights to use, copy,
        modify, merge, publish, distribute, sublicense, and/or sell copies of
        the Software, and to permit persons to whom the Software is furnished to
        do so, subject to the following conditions: The above copyright notice
        and this permission notice shall be included in all copies or
        substantial portions of the Software. THE SOFTWARE IS PROVIDED “AS IS”,
        WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
        LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
        PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
        HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN
        AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
        CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
        SOFTWARE.
      </p>
    </div>
    <br />
    <div style={{padding: '10px 0px 0px 21px', fontWeight: 'bold'}} id={'L341'}>
      9. Unlicense
    </div>
    <div style={{padding: '10px 0px 0px 21px', whiteSpace: 'pre-wrap'}}>
      License Text:
      <p style={{margin: '0px'}}>
        This is free and unencumbered software released into the public domain.
        Anyone is free to copy, modify, publish, use, compile, sell, or
        distribute this software, either in source code form or as a compiled
        binary, for any purpose, commercial or non-commercial, and by any means.
        In jurisdictions that recognize copyright laws, the author or authors of
        this software dedicate any and all copyright interest in the software to
        the public domain. We make this dedication for the benefit of the public
        at large and to the detriment of our heirs and successors. We intend
        this dedication to be an overt act of relinquishment in perpetuity of
        all present and future rights to this software under copyright law. THE
        SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
        THE AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
        IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
        CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
        SOFTWARE.
      </p>
    </div>
    <br />
    <div style={{fontSize: '32px', textAlign: 'center'}}></div>
    </div>
  </>
)

export default Notice
